// @flow

import React from 'react'
import {Link, withRouter, Route} from 'react-router-dom'
import firebaseMenuMaker from '../firebase-menumaker'
import MenuMaker from '../MenuMaker/MenuMaker'
import './dashboard.css'
import request from 'superagent'
import Devices from '../Devices'
const DataContext = React.createContext('')

/*
This is the dashboard/homepage of one restaurnat/shop.
showing:
- list of TVs
- list of available designs along with possible screenshots.
*/
const mapFirebaseChildren = (snapshot, func) => {
  let _ = []
  let index = 1
  snapshot.forEach((s) => {
    _.push(func(s, index))
    index++
  })
  return _
}

class Dashboard extends React.Component {
  state = {
    shopSnapshot: null
  }
  componentDidMount() {
    this.shopRef = firebaseMenuMaker.database()
      .ref(`shopsInfo/${this.props.shopId}`)
    this.shopRef.on('value', (snapshot) => {
      // snapshot docs: https://firebase.google.com/docs/reference/js/firebase.database.DataSnapshot
      console.log('snapshot.val()', snapshot.val())
      this.setState({ shopSnapshot: snapshot })
    })
  }
  componentWillUnmount () {
    this.shopRef.off()
  }
  createNewDesignOfType = (type) => {
    let refPromise = this.shopRef.child('designsIndex').push({
      name: 'Untitled Print',
      pages: {},
      shopId: this.props.shopId
    })
    refPromise.child('pages').push({ name: 'Untitled' })
  }
  createNewTvScreen = () => {
    let refPromise = this.shopRef.child('tvsIndex').push({
      name: "Untitled TV",
      pages: {},
      shopId: this.props.shopId
    })
    refPromise.child('pages').push({ name: 'Untitled' })
  }
  createNewPageForDesign = (designId) => {
    let pageRefPromise = this.shopRef.child(`designsIndex/${designId}/pages`)
      .push({
        name: 'Untitled'
      })
    pageRefPromise
      .then(() => {
        this.props.history.push(`${this.props.match.url}/designs/${designId}/${pageRefPromise.key}`)
      })
  }
  async publishScreen (tvId, designId) {
    // hide doc from general navigation
    // copy index and design file to tv-production-branch
    
    const tvProductionsRef = firebaseMenuMaker.database().ref('tvProductions')
    const designSnap = await firebaseMenuMaker.database().ref('designs').child(designId).once('value')
    const firstPageId = Object.keys(designSnap.child('pages').val())[0]
    const {width, height} = designSnap.child('pages').child(firstPageId).val()
    console.log('got width height:', {width, height})
    let url = "https://lcicj3wbt1.execute-api.us-east-1.amazonaws.com/dev/hello-world" // folder: puppeteer-llamda

    //remove tv state
    await firebaseMenuMaker.database().ref(`tvStates/${this.props.shopId}/${tvId}`).set(null)
    await tvProductionsRef.child(this.props.shopId).child(tvId).set({
      _needsScreenshot: Date.now(),
      design: designSnap.val(),
    })
    const json = {
      designId, shopId: this.props.shopId, pageId: firstPageId , tvId,
      width,
      height,
      deviceScaleFactor: 2
      }
    console.log(json)
    let response = await request.post(url)
      .set('Content-Type', 'application/json')
      .send(JSON.stringify(json))
    const body = response.body
    console.log(body)
    if (body && body.url) {
      console.log(body.url)
    }
  }
  render () {
    let shopSnapshot = this.state.shopSnapshot
    if (!shopSnapshot) {return null}
    return(
      <div>
        <Route path={this.props.match.url} exact render={() => (
          <div className="dashboard no-print">
            <Devices shopId={this.props.shopId} />

            {/* 📺 TV Top-level nav */}
            <div className="dashboard__section">
              <h2 className="dashboard__section-title">TV Screen Designs
                <button
                  className="new-document-button"
                  onClick={this.createNewTvScreen}>New TV Design</button>
              </h2>


              <ul className="tv__list">
                {mapFirebaseChildren(shopSnapshot.child('tvsIndex'), (IndexSnapshot) => {
                  let firstPageId = Object.keys(IndexSnapshot.child('pages').val() || {})[0]
                  let entryPath = firstPageId ? ('/' + firstPageId) : ''
                  return(
                    <li>
                      <Link to={`${this.props.match.url}/tvs/${IndexSnapshot.key}${entryPath}`}>
                        <div className="tv-preview">

                        </div>
                        <div className="tv-name">{IndexSnapshot.child('name').val()}</div>
                      </Link>
                    </li>
                  )
                })}
              </ul>


            </div>

            {/* 🖨 PRINT Top-level nav */}
            <div className="dashboard__section">
              <h2 className="dashboard__section-title">Print Designs
                <button
                  className="new-document-button"
                  onClick={this.createNewDesignOfType.bind(this, 'tv')}>New Print Design</button>
              </h2>
              <ul className="dashboard__document-list">
                {mapFirebaseChildren(shopSnapshot.child('designsIndex'), (IndexSnapshot) => {
                  let firstPageId = Object.keys(IndexSnapshot.child('pages').val() || {})[0]
                  let entryPath = firstPageId ? ('/' + firstPageId) : ''
                  return(<li
                    className="dashboard__document"
                    key={IndexSnapshot.key}>
                    <Link to={`${this.props.match.url}/designs/${IndexSnapshot.key}${entryPath}`}>
                    <div className="dashboard__document-preview">
                      {mapFirebaseChildren(IndexSnapshot.child('pages'), (pageSnapshot) => {
                        return(
                          <img src={pageSnapshot.child('preview/url').val()} alt=""/>
                        )
                      })}
                    </div>
                    <div className="document__name">{IndexSnapshot.child('name').val()}</div>
                  </Link>
                </li>)})}
              </ul>

            </div>

        </div>
      )}/>

        {/* 🖨 PRINT Design Title Bar and Name Editor */}
        <Route path={`${this.props.match.url}/designs/:designId`} render={({match}) => {
          let designNameSnap = shopSnapshot.child(`designsIndex/${match.params.designId}/name`)
          return(<div className="document-header no-print">
             
            <Link to={this.props.match.url}>All Designs</Link>
            /
            <input
              className="document-header__name-input"
              type="text" value={designNameSnap.val()} onChange={(e) => {
              designNameSnap.ref.set(e.target.value)
            }}/>
          </div>)
        }}
        />
        {/* 📺 TV Design Title Bar and Name Editor */}
        <Route path={`${this.props.match.url}/tvs/:designId`} render={({match}) => {
          let designNameSnap = shopSnapshot.child(`tvsIndex/${match.params.designId}/name`)
          let designTVIdSnap = shopSnapshot.child(`tvsIndex/${match.params.designId}/tvId`)
          return(<div className="document-header no-print">
            <span className="site-title-inline-logo">AVOGRIDO</span> / 
            <Link to={this.props.match.url}>All Designs</Link>
            /
            <input
              className="document-header__name-input"
              type="text" value={designNameSnap.val()} onChange={(e) => {
              designNameSnap.ref.set(e.target.value)
            }}/>

            <div className="publisher">
              TV-ID: <input
                value={designTVIdSnap.val()}
                onChange={(e) => designTVIdSnap.ref.set(e.target.value)}
                type="text"/>
              <button onClick={this.publishScreen.bind(this, designTVIdSnap.val(), match.params.designId)}>Publish Slides Design</button>
            </div>
            
          </div>)
        }}
        />
        {/* 🖨 PRINT Design Page Navigation */}
        <Route path={`${this.props.match.url}/designs/:designId`} render={({match}) => {
          return(
            <nav className="page-nav no-print">
                {/* <h3>Pages: </h3> */}
                {mapFirebaseChildren(shopSnapshot.child(`designsIndex/${match.params.designId}/pages`), (pagesSnap, index) => {
                  let pagePath = `${this.props.match.url}/designs/${match.params.designId}/${pagesSnap.key}`
                  return (
                    <Route path={pagePath} key={pagesSnap.key} children={({match: isActive}) => {
                      return(
                        <div className={isActive ? 'page-nav__page-item active': 'page-nav__page-item'} key={pagesSnap.key}>
                          <Link
                            to={pagePath}>
                            <div className="page-nav__preview-container">
                              <img src={pagesSnap.child('preview/url').val()} alt=""/>
                            </div>
                            {/* {pagesSnap.child('name').val()} */}
                            <div className="page-nav__page-name">{index}</div>
                          </Link>
                        </div>
                      )
                    }} />)
                })}

              <button
                className="page-nav__new-page-button"
                onClick={this.createNewPageForDesign.bind(this, match.params.designId)}>NEW PAGE</button>
              {/* <button onClick={this.handleMakeScreenshot}>SHOT</button> */}
            </nav>
          )
        }} />

        {/* 🖨 PRINT Single Page Editor (extract firebase code to this level and request parent ref for Multi-page editor) */}
        <Route path={`${this.props.match.url}/designs/:designId/:pageId`} exact render={({match}) => {
          return(
            <MenuMaker
              shopId={this.props.shopId}
              designId={match.params.designId}
              pageId={match.params.pageId}
             />
          )
        }} />


        {/* 📺 TV Design Page Navigation */}
       { false && <Route path={`${this.props.match.url}/tvs/:designId`} render={({match}) => {
          return(
            <nav className="page-nav no-print">
                {mapFirebaseChildren(shopSnapshot.child(`tvsIndex/${match.params.designId}/pages`), (pagesSnap, index) => {
                  let pagePath = `${this.props.match.url}/tvs/${match.params.designId}/${pagesSnap.key}`
                  return (
                    <Route path={pagePath} key={pagesSnap.key} children={({match: isActive}) => {
                      return(
                        <div className={isActive ? 'page-nav__page-item active': 'page-nav__page-item'} key={pagesSnap.key}>
                          <Link
                            to={pagePath}>
                            <div className="page-nav__preview-container">
                              <img src={pagesSnap.child('preview/url').val()} alt=""/>
                            </div>
                            {/* {pagesSnap.child('name').val()} */}
                            <div className="page-nav__page-name">{index}</div>
                          </Link>
                        </div>
                      )
                    }} />)
                })}

              <button
                className="page-nav__new-page-button"
                onClick={this.createNewPageForDesign.bind(this, match.params.designId)}>NEW SLIDE</button>

            </nav>
          )
        }} />}

        {/* 📺 TV Page Editor */}
        <Route path={`${this.props.match.url}/tvs/:designId/:pageId`} exact render={({match}) => {
          return(
            <MenuMaker
              shopId={this.props.shopId}
              designId={match.params.designId}
              pageId={match.params.pageId}
             />
          )
        }} />
      </div>
    )
  }
}

export default withRouter(Dashboard)
export { DataContext }
